import * as CommonTypes from "../types/common.types"
import http from "./http-common"

class AllyServiceClass {
    private token: string | undefined;
    private config: { headers: { Authorization: string | undefined } };
    private seller: string = '/seller'
    private ally: string = '/ally'
    private passenger: string = '/passenger'
    private tours: string = '/tours'
    private trips: string = '/trips'
    private guider: string = '/guider'
    private driver: string = '/driver'
    private reservation: string = '/reservation'
    private group: string = '/group'
    private payment: string = '/payments'
    constructor(token?: string) {
        this.token = token;
        this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }
    
    setToken(token: string) {
      this.token = token;
      this.config = { headers: { Authorization: `Bearer ${this.token}` } };
    }

    login(data: CommonTypes.DefaultLogin) {
      return http.post(this.ally + '/login', data)
    }

    listTours(date: string) {
      return http.post(this.tours + '/listToursTripsPassengers', {date}, this.config)
    }

    me() {
      return http.get(this.ally + '/me', this.config)
    }

    createGroup() {
      return http.post(this.group + '/create', {}, this.config)
    }

    createPassenger(data: Partial<CommonTypes.Passenger>) {
      return http.post(this.passenger + '/create', data, this.config)
    }

    getReservation(reservation_id: string) {
      return http.get(this.reservation + `/reservation/${reservation_id}`, this.config)
    }

    editReservation(reservation_id: string, data: CommonTypes.Reservation) {
      return http.put(this.reservation + `/edit/${reservation_id}`, data, this.config)
    }

    createReservation(data: CommonTypes.SubmitReservation) {
      return http.post(this.reservation + '/create', data, this.config)
    }

    // "Mis reservas" (perfil): reservas con algún tour entre from y to ('yyyy-MM-dd'), completas.
    listMyReservations(from: string, to: string) {
      return http.post(this.ally + '/my-reservations', { from, to }, this.config)
    }

    // Liquidaciones (portal): sus pagos pendientes con abonos y pasajeros, lo no cobrado y los totales.
    listMySettlements() {
      return http.get(this.ally + '/my-settlements', this.config)
    }

    getPassengerPlan(id: string) {
      return http.get(this.passenger + `/passenger-plan?passenger_id=${id}`, this.config)
    }

    deleteReservation(reservation_id: string) {
      return http.delete(this.reservation + `/delete/${reservation_id}`, this.config)
    }

    listPassengers() {
      return http.get(this.passenger + '/ally', this.config)
    }
}

const AllyService = new AllyServiceClass()

export default AllyService